import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';
// import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { NavContext } from '../context/NavProvider';
import { Seo } from '../components/Seo';
import LayoutMain from '../components/layouts/LayoutMain';
import Sidebar from '../components/Sidebar';
import Search from '../components/Search';
import Title from '../components/elements/Title';
import Locations from '../components/Locations';
import { filterTags as filterTagsData } from '../components/utils/filter-tags';
import { ConfiguratorContext } from '../context/ConfiguratorProvider';
import { cleanSlug } from '../components/utils/clean-slug';

import {
  wrapAbove,
  wrapAboveContent,
  wrapAboveContentWrap,
  wrapAboveText,
  wrapBelow,
  // wrapAboveTitle,
  // wrapAboveFeaturedImage,
} from './defaultStyles.module.scss';

const LocationSearchTemplate = ({ pageContext }) => {
  const [isOverflowActive, setIsOverflowActive] = useState(false);

  const { isDev } = useContext(ConfiguratorContext);

  // const {
  //   locationAddress,
  //   locationWebsite,
  //   locationPhoneNumber,
  //   leImageVenue,
  //   aboutLocation,
  //   venueMenu,
  //   whatYouWillLoveAboutIt,
  //   insiderTips,
  // } = pageContext.locationData;

  const locationsDataQuery = useStaticQuery(graphql`
    query LocationsQuery {
      allWpVenue(sort: { date: DESC }) {
        edges {
          node {
            title
            uri
            slug
            excerpt
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      # webpOptions: { quality: 90 }
                      # formats: WEBP
                      avifOptions: { quality: 90 }
                      formats: AVIF
                      width: 300
                      height: 500
                      placeholder: NONE
                      layout: CONSTRAINED
                      breakpoints: [300]
                      sizes: "(min-width: 300px) 300px, 100vw"
                    )
                  }
                }
              }
            }
            locationsACF {
              leImageVenue
              venueSearch {
                budget
                capacity
                indoorOutdoor
                location
                other
              }
            }
            categories {
              nodes {
                slug
              }
            }
          }
        }
      }
    }
  `);

  // set locations
  const [locationsData, setLocationsData] = useState([]);
  // get slug from pageContext
  const { slug } = pageContext;

  // Filter locations based on the slug from pageContext
  // "wedding-venues", "nyc-elopement-locations", "engagement-locations"
  useEffect(() => {
    const filteredLocations = locationsDataQuery.allWpVenue.edges.filter(
      (location) => {
        return location.node.categories.nodes.some(
          (category) => category.slug === slug
        );
      }
    );
    // Clean the slug and uri properties of the filtered locations
    // remove -2 from the slug, and -2/ from the uri
    const cleanedLocations = filteredLocations.map((location) => {
      return {
        ...location,
        node: {
          ...location.node,
          slug: cleanSlug(location.node.slug),
          uri: cleanSlug(location.node.uri),
        },
      };
    });
    // Update locationsData with the filtered locations
    setLocationsData(cleanedLocations);
    // }
    // }, [locationsDataQuery.allWpVenue.edges]);
  }, [locationsDataQuery.allWpVenue.edges, slug]);

  // console.log('LOCATIONS DATA', locationsData);

  // hanlde search, filters
  const [searchInputValue, setSearchInputValue] = useState('');
  const [searchLocationsData, setSearchLocationsData] = useState(null);
  const [searchLocationsFilterData, setSearchLoactionsFilterData] =
    useState(null);
  // const [searchResultEmpty, setSearchResultEmpty] = useState(false);
  const [searchFilterTags, setSearchFilterTags] = useState({
    activeFilters: [],
  });

  // handle filters
  const [appliedStatus, setAppliedStatus] = useState('');

  const [filterTags, setFilterTags] = useState(() => {
    // Create a deep copy of filterTagsData
    return filterTagsData.map((filterTag) => ({
      ...filterTag,
      activeFilterIdx: [...filterTag.activeFilterIdx],
    }));
  });

  // Reset filter tags on component mount
  // solves issue with filter tags not resetting
  // when navigating between wedding venues,
  // engagement and elopement locations
  const location = useLocation();
  const [pathname, setPathname] = useState(location.pathname);

  useEffect(() => {
    setPathname(location.pathname);
    resetSearchResults();
    setFilterTags(() => {
      // Create a deep copy of filterTagsData
      return filterTagsData.map((filterTag) => ({
        ...filterTag,
        activeFilterIdx: [...filterTag.activeFilterIdx],
      }));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let searchResult;
    if (!searchLocationsFilterData) {
      searchResult = locationsData.filter((location) => {
        return location.node.title
          .toLowerCase()
          .split('-')
          .join(' ')
          .includes(searchInputValue.toLowerCase());
      });
    } else {
      searchResult = searchLocationsFilterData.filter((location) => {
        return location.node.title
          .toLowerCase()
          .split('-')
          .join(' ')
          .includes(searchInputValue.toLowerCase());
      });
    }
    setSearchLocationsData(searchResult);
  }, [locationsData, searchInputValue, searchLocationsFilterData]);

  // handle apply search filters
  useEffect(() => {
    let locations = filterTags[1].tags.map((l) => l.toLowerCase());

    let hasLocation;
    if (searchFilterTags.activeFilters) {
      hasLocation = searchFilterTags.activeFilters.some((filterLocation) => {
        return locations.includes(filterLocation);
      });
    }

    let selectedLocations;
    if (hasLocation) {
      selectedLocations = locations.filter((location) => {
        return searchFilterTags.activeFilters.includes(location);
      });
    }

    if (appliedStatus === 'added') {
      let searchFilterResult;

      if (hasLocation) {
        let targetLocations = locationsData.filter((data) => {
          return selectedLocations.includes(
            data.node.locationsACF.venueSearch.location.toLowerCase()
          );
        });

        searchFilterResult = targetLocations.filter((targetLocation) => {
          let budget = targetLocation.node.locationsACF.venueSearch.budget
            ? targetLocation.node.locationsACF.venueSearch.budget.map((b) =>
                b.toLowerCase()
              )
            : [];
          // let location = targetLocation.node.locationsACF.locationSearch
          //   .location
          //   ? targetLocation.node.locationsACF.locationSearch.location.toLowerCase()
          //   : null;
          let capacity = targetLocation.node.locationsACF.venueSearch.capacity
            ? targetLocation.node.locationsACF.venueSearch.capacity.map((c) =>
                c.toLowerCase()
              )
            : [];
          let indoorOutdoor = targetLocation.node.locationsACF.venueSearch
            .indoorOutdoor
            ? targetLocation.node.locationsACF.venueSearch.indoorOutdoor.map(
                (id) => id.toLowerCase()
              )
            : [];
          let other = targetLocation.node.locationsACF.venueSearch.other
            ? targetLocation.node.locationsACF.venueSearch.other.map((o) =>
                o.toLowerCase()
              )
            : [];
          let targetFilterLocation = [
            ...budget,
            ...capacity,
            ...indoorOutdoor,
            ...other,
          ];

          let searchFilterTagsActiveFilters =
            searchFilterTags.activeFilters.filter((filter) => {
              return !locations.includes(filter);
            });

          return searchFilterTagsActiveFilters.every((filter) => {
            return targetFilterLocation.includes(filter);
          });
        });
      } else {
        // filter all
        searchFilterResult = locationsData.filter((data) => {
          let budget = data.node.locationsACF.venueSearch.budget
            ? data.node.locationsACF.venueSearch.budget.map((b) =>
                b.toLowerCase()
              )
            : [];
          let location = data.node.locationsACF.venueSearch.location
            ? data.node.locationsACF.venueSearch.location.toLowerCase()
            : null;
          let capacity = data.node.locationsACF.venueSearch.capacity
            ? data.node.locationsACF.venueSearch.capacity.map((c) =>
                c.toLowerCase()
              )
            : [];
          let indoorOutdoor = data.node.locationsACF.venueSearch.indoorOutdoor
            ? data.node.locationsACF.venueSearch.indoorOutdoor.map((id) =>
                id.toLowerCase()
              )
            : [];
          let other = data.node.locationsACF.venueSearch.other
            ? data.node.locationsACF.venueSearch.other.map((o) =>
                o.toLowerCase()
              )
            : [];

          let targetFilter = [
            ...budget,
            location,
            ...capacity,
            ...indoorOutdoor,
            ...other,
          ];

          return searchFilterTags.activeFilters.every((filter) => {
            return targetFilter.includes(filter);
          });
        });
      }

      setSearchLoactionsFilterData(searchFilterResult);
      setSearchLocationsData(searchFilterResult);
      // setSearchFilterResults(searchFilterResult);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationsData, appliedStatus, searchFilterTags]);

  // clear input field, and previous search results
  const resetSearchResults = () => {
    setSearchLoactionsFilterData(null);
    setSearchLocationsData(null);
    setSearchInputValue('');
    setSearchFilterTags({ activeFilters: [] });
    setFilterTags([]);
  };

  const applySearchFilters = (filter, tag, status, filterTags) => {
    if (
      searchFilterTags.activeFilters.indexOf(tag.toLowerCase()) !== -1 &&
      status === 'removed'
    ) {
      setSearchFilterTags((state) => {
        const activeFilters = state.activeFilters.filter(
          (activeTag) => activeTag !== tag.toLowerCase()
        );
        return { activeFilters };
      });
    } else {
      setSearchFilterTags((state) => {
        const activeFilters = [...state.activeFilters, tag.toLowerCase()];
        setAppliedStatus(status.toLowerCase());
        return { activeFilters };
      });
    }
  };

  const handleChangeSearchInput = (event) => {
    setSearchInputValue(event.target.value);
    // setSearchInputValue(event.target.value.trim());
  };

  return (
    <LayoutMain>
      {isDev && <pre>LocationSearch</pre>}
      <div className={wrapAbove}>
        <NavContext.Consumer>
          {(context) => (
            <Sidebar
              addAltClass={false}
              isHomePage={false}
              isActive={context.isActive}
              setIsActive={() => context.setIsActive()}
              isToggleStyle={context.isToggleStyle}
              setToggleStyle={() => context.setToggleStyle()}
              toggleActive={() => context.toggleActive()}
              onClickOutside={() => {
                context.setIsActive(false);
                context.setToggleStyle(false);
              }}
            />
          )}
        </NavContext.Consumer>
        <div className={wrapAboveContentWrap}>
          <div className={wrapAboveContent}>
            <Title text={pageContext.title} size="2" />
            <div className={wrapAboveText}>
              <div
                dangerouslySetInnerHTML={{ __html: pageContext.content }}
              ></div>
            </div>
            {/* <div className={wrapAboveFeaturedImage}>
              {pageContext.featuredImage.node !== null && (
                <GatsbyImage
                  alt=""
                  image={
                    pageContext.featuredImage.node.localFile.childImageSharp
                      .gatsbyImageData
                  }
                />
              )}
            </div> */}
          </div>
        </div>
      </div>
      <div className={`${wrapBelow} locations`}>
        <Search
          searchText="Filter Locations"
          useOnClickFilter={true}
          setIsOverflowActive={setIsOverflowActive}
          locationsData={locationsData}
          // onClickSearchInput={onClickSearchInput}
          // onClickSearchButton={onClickSearchButton}
          handleChangeSearchInput={handleChangeSearchInput}
          searchInputValue={searchInputValue}
          applySearchFilters={applySearchFilters}
          pathname={pathname}
          filterTags={filterTags}
        />
        <section>
          <div className="content-container locations-search">
            {(searchLocationsData && searchLocationsData.length === 0) ||
            (!searchLocationsData && locationsData.length === 0) ? (
              'No results.'
            ) : (
              <Locations
                // getCategoryPath={getCategoryPath}
                isSearch={true}
                locationsData={
                  searchLocationsData ? searchLocationsData : locationsData
                }
              />
            )}
          </div>
        </section>
      </div>
    </LayoutMain>
  );
};
export default LocationSearchTemplate;

// export const Head = ({ pageContext }) => (
//   <Seo title={`${pageContext.title} | Le Image`} />
// );
export const Head = ({ pageContext }) => {
  const seo = pageContext.seo;
  const featuredImage =
    pageContext.featuredImage?.node?.localFile?.publicURL || '';

  return (
    <Seo
      bodyClass={pageContext.customBodyClass}
      title={seo.title}
      description={seo.metaDesc}
      rootUri={pageContext.rootUri}
      featuredImage={featuredImage}
      schema={seo.schema ? JSON.parse(seo.schema.raw) : null}
    />
  );
};
